/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    inverse: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: {
        borderBottomColor: '#404040',
        borderBottomWidth: 2,
        color: '#404040'
      }
    },
    {
      if: { focus: true },
      tokens: {
        borderBottomColor: '#000000',
        borderBottomWidth: 4,
        color: '#000000'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        borderBottomColor: '#666666',
        borderBottomWidth: 2,
        color: '#666666'
      }
    },
    {
      if: { focus: true, pressed: true },
      tokens: { borderBottomWidth: 4 }
    },
    {
      if: { inactive: true },
      tokens: {
        borderBottomColor: '#c9c8c8',
        borderBottomWidth: 4,
        color: '#c9c8c8'
      }
    },
    {
      if: { selected: true },
      tokens: {
        borderBottomColor: '#000000',
        borderBottomWidth: 2,
        color: '#000000'
      }
    },
    {
      if: { hover: true, inverse: true },
      tokens: {
        borderBottomColor: '#ffffff',
        borderBottomWidth: 2,
        color: '#ffffff'
      }
    },
    {
      if: { focus: true, inverse: true },
      tokens: {
        borderBottomColor: '#ffffff',
        borderBottomWidth: 4,
        color: '#ffffff'
      }
    },
    {
      if: { inverse: true, pressed: true },
      tokens: {
        borderBottomColor: '#666666',
        borderBottomWidth: 2,
        color: '#666666'
      }
    },
    { if: { inverse: true }, tokens: { color: '#ffffff' } },
    {
      if: { focus: true, inverse: true, pressed: true },
      tokens: { borderBottomWidth: 4 }
    },
    {
      if: { inactive: true, inverse: true },
      tokens: {
        borderBottomColor: '#c9c8c8',
        borderBottomWidth: 4,
        color: '#c9c8c8'
      }
    },
    {
      if: { inverse: true, selected: true },
      tokens: {
        borderBottomColor: '#ffffff',
        borderBottomWidth: 4,
        color: '#ffffff'
      }
    }
  ],
  tokens: {
    alignItems: 'flex-start',
    borderBottomColor: 'transparent',
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    color: '#000000',
    flex: 1,
    fontName: 'StagSans',
    fontScaleCap: 64,
    fontSize: 14,
    fontWeight: '600',
    justifyContent: 'flex-start',
    letterSpacing: 0,
    lineHeight: 1.45,
    paddingBottom: 16,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0
  }
}
export default theme
